import { Link, useLocation } from 'react-router-dom';
import type { PestaniaDeSeccion } from './menu';

interface PropsBarraDeSeccion {
  pestanias: readonly PestaniaDeSeccion[];
}

/** La pestaña activa es la de ruta mas larga que sea prefijo de la actual (fichas, altas). */
function rutaActiva(pestanias: readonly PestaniaDeSeccion[], camino: string): string | undefined {
  return pestanias
    .map((pestania) => pestania.ruta)
    .filter((ruta) => camino === ruta || camino.startsWith(`${ruta}/`))
    .sort((a, b) => b.length - a.length)[0];
}

/** Pestañas de la seccion actual. Con una sola pantalla no se muestra: no aporta nada. */
export function BarraDeSeccion({ pestanias }: PropsBarraDeSeccion) {
  const { pathname } = useLocation();
  if (pestanias.length < 2) return null;
  const activa = rutaActiva(pestanias, pathname);

  return (
    <nav
      aria-label="Pantallas de la sección"
      className="mb-3 flex shrink-0 flex-wrap gap-1 border-b border-slate-300"
    >
      {pestanias.map((pestania) => {
        const esActiva = pestania.ruta === activa;
        return (
          <Link
            key={pestania.ruta}
            to={pestania.ruta}
            aria-current={esActiva ? 'page' : undefined}
            className={[
              '-mb-px min-w-0 rounded-t border border-transparent px-3 py-1.5 text-sm font-medium pointer-coarse:py-2.5',
              esActiva
                ? 'border-slate-300 border-b-white bg-white text-marca-800'
                : 'text-slate-600 hover:bg-slate-100',
            ].join(' ')}
          >
            {pestania.etiqueta}
          </Link>
        );
      })}
    </nav>
  );
}
